import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { useContext } from 'react';
import { PermissionsContext } from '../../../context/PermissionsContext';
import { jsx as _jsx } from "react/jsx-runtime";
const DeleteActionButton = ({
  openModal
}) => {
  const {
    canEditSubject
  } = useContext(PermissionsContext);
  return /*#__PURE__*/_jsx(Tooltip, {
    title: canEditSubject ? null : /*#__PURE__*/_jsx(FormattedMessage, {
      message: "cardPaymentHighlight.paymentHighlight.sidebarActions.noAccess.default"
    }),
    children: /*#__PURE__*/_jsx(Button, {
      onClick: openModal,
      "data-test-id": "payment-sidebar-actions--delete",
      disabled: !canEditSubject,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "cardPaymentHighlight.paymentHighlight.sidebarActions.delete.buttonLabel"
      })
    })
  });
};
export default DeleteActionButton;